<template>
	<div :class="{'page-fixed-height': !activePanel}">
		<div class="sideways-page-one" :class="{'disabled': !activePanel}">
			<!-- BEGIN PAGE BAR -->
			<div class="page-bar">
				<breadcrumb :crumbs="breadcrumbs"></breadcrumb>
			</div>
			<!-- END PAGE BAR -->
			<!-- BEGIN PAGE TITLE-->
	       	<h1 class="page-title">Users</h1>
	        <!-- END PAGE TITLE-->
	        <div class="note note-info">
	            <p>{{ note }}</p>
	        </div>
	        <button type="button" class="btn blue btn-lg" @click="throttledInvite()">Invite a New User</button>
	        <div class="margin-top-20">
	      		<div>

	      			<!-- SEARCH PANEL START -->
      				<div class="portlet box blue-hoki">
      					<div class="portlet-title" @click="toggleSearchPanel()">
      						<div class="caption">
      							<i class="fa fa-search"></i>
      							Search Panel
      						</div>
      						<div class="tools">
      							<a :class="{'expand': !searchCollapse, 'collapse': searchCollapse}"></a>
      						</div>
      					</div>
      					<div class="portlet-body" :class="{'display-hide': searchCollapse}">
      						<form role="form" @submit.prevent="advancedUserSearch()">
			      				<div class="form-body row">
			      					<div class="col-md-6">
			      						<div class="alert alert-danger" v-if="searchError.length">
			                                <button class="close" data-close="alert" @click="clearSearchError()"></button>
			                                <span>{{ searchError }}</span>
			                            </div>
				      					<div class="form-group form-md-line-input form-md-floating-label">
				      						<input type="text" class="form-control input-sm" :class="{'edited': advancedSearch.search.length}" id="search_options_search" v-model="advancedSearch.search" :tabindex="activePanel ? 0 : -1">
				      						<label for="search_options_search">Search</label>
				      						<span class="help-block persist" v-if="computedSearchOptions.length">Searching by <span v-for="(option, index) in computedSearchOptions"><span v-if="index !== 0">, </span>{{ option.name }}</span>.</span>
				      						<span class="help-block persist" v-else>Select search terms below.</span>
				      					</div>
				      					<div class="md-checkbox-inline margin-top-25">
				      						<div class="md-checkbox" v-for="option in advancedSearch.searchOptions">
				      							<input type="checkbox" :id="`advanced_search_checkbox_${option.value}`" class="md-check" v-model="option.checked">
				      							<label :for="`advanced_search_checkbox_${option.value}`">
				      								<span></span>
				      								<span class="check"></span>
				      								<span class="box"></span>
				      								{{ option.name }}
				      							</label>
				      						</div>
			                            </div>
			                        </div>
			                        <div class="col-md-6">
			                        	<div class="form-group form-md-line-input form-md-floating-label">
			                            	<select class="form-control edited" id="search_options_status" v-model="advancedSearch.status" :tabindex="activePanel ? 0 : -1">
			                                    <option value="" disabled></option>
			                                    <option value="any_status">Any User</option>
			                                    <option value="accepted">Active Users</option>
			                                    <option value="pending">Pending Users</option>
			                                    <option value="expired">Expired User Invitations</option>
			                                </select>
			                                <label for="search_options_status">Status</label>
			                            </div>
				      					<div class="form-group form-md-line-input form-md-floating-label">
				      						<typeahead :data="roles" :label="'Role'" :emitter="'role'" @role="updateRole" :objectKey="'role_name'" :passedValue="advancedSearch.role" @onFocus="roleFocus" :tabindex="activePanel ? 0 : -1"></typeahead>
			                            </div>
			                        </div>
			      				</div>
			      				<div class="form-actions right">
			      					<button type="button" class="btn btn-default" :tabindex="activePanel ? 0 : -1" @click="resetUserSearch()"> Reset Search</button>
			      					<button type="submit" class="btn blue" :tabindex="activePanel ? 0 : -1"><i class="fa fa-search"></i> Search</button>
			      				</div>
			      			</form>
      					</div>
      				</div>
      				<!-- SEARCH PANEL END -->

      			</div>
      			<div class="relative-block">

      				<!-- USERS TABLE START -->
		      		<loading-screen :show="loadingUserData" :color="'#3598dc'" :display="'inline'"></loading-screen>
		      		<div v-if="loadingUserData === false">
		      			<div class="clearfix">
		      				<dropdown>
								<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown">
									Sort By<span v-if="sortBy.field"><b>: {{ capitalize(sortBy.field) }} <i class="fa fa-sort-alpha-asc" v-if="sortBy.order === 'asc'"></i><i class="fa fa-sort-alpha-desc" v-if="sortBy.order === 'desc'"></i></b></span>
									<i class="fa fa-angle-down"></i>
								</button>
								<ul slot="dropdown-menu" class="dropdown-menu">
									<li class="rounded-button-group-block">
										<div class="btn-group" data-toggle="buttons">
											<label class="btn blue btn-outline" for="sort_asc" :class="{'active': sortBy.order === 'asc'}">
												<input type="radio" class="toggle" id="sort_asc" value="asc" v-model="sortBy.order">
												<i class="fa fa-sort-alpha-asc"></i>
											</label>
											<label class="btn blue btn-outline" for="sort_desc" :class="{'active': sortBy.order === 'desc'}">
												<input type="radio" class="toggle" id="sort_desc" value="desc" v-model="sortBy.order">
												<i class="fa fa-sort-alpha-desc"></i>
											</label>
										</div>
									</li>
									<li :class="{'active': sortBy.field === 'first_name'}">
										<a @click="setSortField('first_name')">First Name</a>
									</li>
									<li :class="{'active': sortBy.field === 'last_name'}">
										<a @click="setSortField('last_name')">Last Name</a>
									</li>
									<li :class="{'active': sortBy.field === 'email'}">
										<a @click="setSortField('email')">Email</a>
									</li>
									<li :class="{'active': sortBy.field === 'role'}">
										<a @click="setSortField('role')">Role</a>
									</li>
								</ul>
							</dropdown>
							<page-results class="pull-right" :totalResults="totalResults" :activePage="activePage" @pageResults="pageResultsUpdate"></page-results>
		      			</div>
		      			<div class="margin-top-20">
		      				<pagination :passedPage="activePage" :numPages="numPages" @activePageChange="activePageUpdate"></pagination>
		      			</div>
		      			<div class="margin-top-30 row search-content-4" v-if="numPages !== 0">
		      				<div class="search-table table-responsive">
		      					<table class="table table-bordered table-striped table-condensed">
		      						<thead class="bg-blue">
		      							<tr>
		      								<th></th>
		      								<th></th>
		      								<th><a class="no-click">Role</a></th>
		      								<th><a class="no-click">Actions</a></th>
		      							</tr>
		      						</thead>
		      						<tbody>
		      							<tr v-for="user in users">
		      								<td class="profile-image-table-row">
		      									<div class="missing-profile-image">
		      										<span v-if="user.name.first_name || user.name.last_name">{{ user.name.first_name.toUpperCase().substring(0, 1) }}{{ user.name.last_name.toUpperCase().substring(0, 1) }}</span>
				      								<span v-else>{{ user.email.toUpperCase().substring(0, 1) }}</span>
		      									</div>
		      								</td>
		      								<td>
		      									<h3 v-if="user.name.first_name.length && user.name.last_name.length">{{ user.name.first_name }} {{ user.name.last_name }} <small class="font-red-thunderbird" v-if="user.invite_status !== 'accepted'">(Pending)</small></h3>
		      									<h3 v-else><small class="font-red-thunderbird" v-if="user.invite_status !== 'accepted'">(Pending)</small></h3>
		      									<p>{{ user.email }}</p>
		      								</td>
		      								<td>{{ user.role_name }}</td>
		      								<td>
		      									<dropdown>
													<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown">
														<i class="fa fa-cogs"></i>
													</button>
													<ul slot="dropdown-menu" class="dropdown-menu">
														<li>
															<a>Promote User</a>
														</li>
														<li v-if="user.invite_status !== 'pending'">
															<a @click="deleteUserConfirmation('delete', user)">Delete User</a>
														</li>
														<li v-if="user.invite_status === 'expired'">
															<a @click="resendUserInvitation(user)">Resend User Invitation</a>
														<li v-if="user.invite_status === 'pending'">
															<a @click="deleteUserConfirmation('cancel_invitation', user)">Cancel User Invitation</a>
														</li>
													</ul>
												</dropdown>
		      								</td>
		      							</tr>
		      						</tbody>
		      					</table>
		      				</div>
		      			</div>
		      			<no-results :show="numPages === 0" :type="'users'"></no-results>
		      			<pagination :passedPage="activePage" :numPages="numPages" @activePageChange="activePageUpdate"></pagination>
		      		</div>
		      		<!-- USERS TABLE END -->

      			</div>
      		</div>
		</div>

		<!-- PANEL COMPONENTS START -->
	    <div class="sideways-page-two" :class="{'active': !activePanel, 'inactive': activePanel}" :style="{height: computedHeight}">
	    	<div class="sideways-blank-fold">
	    		<div class="text-center">
	    			<button type="button" class="btn blue btn-lg margin-bottom-10" @click="closePanel()">Return to this page</button>
	    		</div>
	    	</div>
	    	<invite-user :baseRoute="baseRoute" :baseRouteName="baseRouteName" :businessId="businessId" :locationId="locationId"></invite-user>
	    </div>
	    <!-- PANEL COMPONENTS END -->

	</div>
</template>
<script>
import $ from 'jquery'
import Breadcrumb from '../../modules/Breadcrumb'
import Dropdown from '../../modules/Dropdown'
import LoadingScreen from '../../modules/LoadingScreen'
import NoResults from '../../modules/NoResults'
import PageResults from '../../modules/PageResults'
import Pagination from '../../modules/Pagination'
import Typeahead from '../../modules/Typeahead'
import { throttle, debounce } from 'lodash'
import Account from '../../../controllers/Account'
import Auth from '../../../controllers/Auth'
import Role from '../../../controllers/Roles'
import InviteUser from './components/InviteUser'

/**
 * Users module is a page for the users dashboard and creation process.
 * @class Users
 * @prop {array} breadcrumbs - The breadcrumbs array that leads to the current path.
 * @prop {string} note - The note explaining what the dashboard is used for.
 * @prop {number} businessId - Used to pass the business id of the business the user is being invited to.
 * @prop {number} locationId - Used to pass the location id of the location the user is being invited to.
 * @prop {string} baseRoute - The route of the component that this is being called from.
 * @prop {string} baseRouteName - The name of the route of the component that this is being called from.
 * @since 0.0.8
 */

export default {
	name: 'users',
	props: {
		breadcrumbs: {
			type: Array,
			required: true,
			default: () => { return [] }
		},
		note: {
			type: String,
			default: ''
		},
		businessId: {
			type: Number,
			required: true
		},
		locationId: {
			type: Number,
			required: false
		},
		baseRoute: {
			type: String,
			required: true
		},
		baseRouteName: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			activePanel: true,
			computedHeight: 0,
			users: [],
			roles: [],
			roleFocused: false,
			searchCollapse: true,
			advancedSearch: {
				search: '',
				searchOptions: [{name: 'First Name', value: 'first_name', checked: true}, {name: 'Last Name', value: 'last_name', checked: true}, {name: 'Email', value: 'email', checked: true}],
				role: {role_name: 'Any Role'},
				status: 'any_status'
			},
			sortBy: {
				field: 'first_name',
				order: 'asc'
			},
			searchError: '',
			pageResultsValue: 0,
			numPages: 1,
			totalResults: 0,
			activePage: 1,
			loadingUserData: false
		}
	},
	/**
	 * Run on `created` to initialize the throttle event and set the activePanel
	 * @function
	 * @returns {undefined}
	 * @memberof Users
	 * @version 0.0.8
	 */
	created () {
		this.throttledInvite = throttle(() => {
			this.inviteUser()
		}, 500, { 'trailing': false })

		if (this.$route.name !== this.baseRouteName) {
			this.activePanel = false
		}

		let _this = this

		this.computeHeight()

		$(window).on('resize', debounce(() => {
			_this.computeHeight()
		}, 200))
	},
	computed: {
		/**
		 * Compute active search options for use in displaying in sentence format.
		 * @function
		 * @returns {array} - An array of active search option objects.
		 * @memberof Users
		 * @version 0.0.8
		 */
		computedSearchOptions () {
			return this.advancedSearch.searchOptions.filter(option => {
				return option.checked
			})
		}
	},
	methods: {
		/**
		 * To compute height to display based on window height and navbar
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		computeHeight () {
			const height = $(window).height() - 50
			this.computedHeight = height + 'px'
		},
		/**
		 * To close anything active in the side panel by redirecting to the users dashboard route
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		closePanel () {
			this.$router.push(this.baseRoute)
		},
		/**
		 * To toggle the search panel, initially set to closed
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		toggleSearchPanel () {
			this.searchCollapse = !this.searchCollapse
		},
		/**
		 * To clear the current search error.
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		clearSearchError () {
			this.searchError = ''
		},
		/**
		 * To update the role search field based on the value sent from the typeahead component
		 * @function
		 * @param {object} val - the selected role object.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		updateRole (val) {
			if (val && val.role_name) {
				this.advancedSearch.role = val
			} else {
				this.advancedSearch.role = {role_name: 'Any Role'}
			}
		},
		/**
		 * To check if this is the first time the role field has been focused on in order to pull in all roles.
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		roleFocus () {
			if (!this.roleFocused) {
				this.roleFocused = true
				this.getRoles()
			}
		},
		/**
		 * To send the advanced search options to the backend to fetch users.
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof Users
		 * @version 0.0.8
		 */
		advancedUserSearch () {
			this.clearSearchError()
			if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
				this.searchError = 'In order to use the search field your term must be at least 3 characters.'
			} else if (this.advancedSearch.search.length && !this.computedSearchOptions.length) {
				this.searchError = 'In order to use the search field you must select at least one field to search by.'
			} else {
				if (parseInt(this.activePage) === 1) {
					this.getUsers(1)
				} else {
					this.activePageUpdate(1)
				}
			}
		},
		/**
		 * To clear the current user search criteria.
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		resetUserSearch () {
			this.advancedSearch = {
				search: '',
				searchOptions: [{name: 'First Name', value: 'first_name', checked: true}, {name: 'Last Name', value: 'last_name', checked: true}, {name: 'Email', value: 'email', checked: true}],
				role: {role_name: 'Any Role'},
				status: 'any_status'
			}
			this.clearSearchError()
		},
		/**
		 * To catch updates from the PageResults component when the number of page results is updated.
		 * @function
		 * @param {integer} val - The number of page results to be returned.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		pageResultsUpdate (val) {
			if (parseInt(this.pageResultsValue) !== parseInt(val)) {
				this.pageResultsValue = val
				if (parseInt(this.activePage) === 1) {
					this.getUsers(1)
				} else {
					this.activePageUpdate(1)
				}
			}
		},
		/**
		 * To update the currently active pagination page.
		 * @function
		 * @param {integer} val - An integer representing the page number that we are updating to.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		activePageUpdate (val) {
			if (parseInt(this.activePage) !== parseInt(val)) {
				this.activePage = val
				this.getUsers(this.activePage)
			}
		},
		/**
		 * To update the sort by field and make a backend call to pull the sorted data.
		 * @function
		 * @param {string} field - The field that the user wants to sort by.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		setSortField (field) {
			if (field !== this.sortBy.field) {
				this.sortBy.field = field
				if (parseInt(this.activePage) === 1) {
					this.getUsers(1)
				} else {
					this.activePageUpdate(1)
				}
			}
		},
		/**
		 * To capitalize a value (note that this is currently only functional for words with 1 space)
		 * @function
		 * @param {string} val - The value to be capitalized.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		capitalize (val) {
			let output

			val = val.replace(/_/g, ' ')
			const index = val.indexOf(' ')

			if (index !== -1) {
				output = val.substring(0, 1).toUpperCase() + val.substring(1, index + 1) + val.substring(index + 1, index + 2).toUpperCase() + val.substring(index + 2)
			} else {
				output = val.substring(0, 1).toUpperCase() + val.substring(1)
			}
			return output
		},
		/**
		 * To format the search criteria for use in the api call
		 * @function
		 * @returns {object} - An object of the formated search data
		 * @memberof Users
		 * @version 0.0.8
		 */
		formatSearchCriteria () {
			let searchCriteria = {
				invite_status: 'any'
			}

			if (this.advancedSearch.role.role_name !== 'Any Role') {
				searchCriteria.role_id = this.advancedSearch.role.role_id
			}

			if (this.advancedSearch.status !== 'any_status') {
				searchCriteria.invite_status = this.advancedSearch.status
			}

			if (this.advancedSearch.search.length > 2 && this.computedSearchOptions.length) {
				searchCriteria.search_query = this.advancedSearch.search
				let searchIn = ''
				for (let key in this.computedSearchOptions) {
					if (parseInt(key) !== 0) {
						searchIn += ','
					}
					searchIn += this.computedSearchOptions[key].value
				}
				searchCriteria.search_in = searchIn
			}

			return searchCriteria
		},
		/**
		 * To get a list of users for the current page.
		 * @function
		 * @param {integer} pageNumber - The current page that we are retrieving results for.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof Users
		 * @version 0.0.8
		 * @todo Remove timeout
		 */
		getUsers (pageNumber) {
			if (!this.businessId) {
				return
			}

			this.loadingUserData = true
			this.users = []

			let _this = this
			const searchCriteria = this.formatSearchCriteria()
			const sortCriteria = {sort_by: this.sortBy.field, sort_order: this.sortBy.order}

			let accountType = 'business'
			if (this.locationId) {
				accountType = 'location'
			}

			return Account.getUsers(this.businessId, this.locationId, accountType, pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(response => {
				_this.users = response.payload.accounts
				_this.numPages = response.payload.number_of_pages
				_this.totalResults = response.payload.number_of_records
				// Timeout is temporary until backend data is real
				setTimeout(() => { _this.loadingUserData = false }, 500)
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'no_accounts_found':
						_this.numPages = 0
						_this.totalResults = 0
						break

					case 'invalid_business':
						_this.numPages = 0
						_this.totalResults = 0
						_this.$swal({
							title: 'Error',
							html: 'There is an issue with your business account. Please contact your admin.',
							type: 'warning'
						})
						break

					case 'business_not_found':
						_this.numPages = 0
						_this.totalResults = 0
						_this.$swal({
							title: 'Error',
							html: 'There is an issue with your business account. Please contact your admin.',
							type: 'warning'
						})
						break

					case 'invalid_page_number':
						_this.numPages = e.responseJSON.payload.number_of_pages
						_this.totalResults = e.responseJSON.payload.number_of_records
						if (_this.numPages !== 0) {
							_this.getUsers(e.responseJSON.payload.number_of_pages)
						}
						break
					default:
						// No default
					}
				}
				_this.loadingUserData = false
			}))
		},
		/**
		 * To get a list of all roles for the company
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof Users
		 * @version 0.0.8
		 */
		getRoles () {
			let _this = this

			if (!this.locationId) {
				return Role.getRoles(this.businessId).then(response => {
					_this.roles = response.payload.roles
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'no_roles_found':
							// This should never happen but if it does then the user should just not have a list of roles to choose from
							break

						case 'business_not_found':
							_this.$swal({
								title: 'Error',
								html: 'There is an issue with your business account. Please contact your admin.',
								type: 'warning'
							})
							break

						case 'invalid_business':
							_this.$swal({
								title: 'Error',
								html: 'You do not have access to this business.',
								type: 'warning'
							})
							break

						default:
							// No default
						}
					}
				}))
			}
		},
		/**
		 * To disconnect a user from the current business.
		 * @function
		 * @param {string} type - Either `delete` or `cancel_invitation` in order to display the appropriate message.
		 * @param {object} user - The user that is being removed.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		deleteUserConfirmation (type, user) {
			let _this = this
			const username = user.name.first_name && user.name.last_name ? user.name.first_name + ' ' + user.name.last_name : user.email
			let buttonText = ''
			let successMessage = ''

			if (type === 'delete') {
				buttonText = 'Delete User'
				successMessage = '<b>' + username + '</b> has been deleted.'
			} else if (type === 'cancel_invitation') {
				buttonText = 'Cancel Invitation'
				successMessage = 'The user invitation has been cancelled.'
			}

			this.$swal({
				title: 'Are you sure?',
				html: '<b>' + username + '</b> will no longer be able to access your business.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: buttonText,
				confirmButtonColor: '#d9534f',
				cancelButtonText: 'Cancel',
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				showLoaderOnConfirm: true,
				preConfirm () {
					return new Promise((resolve, reject) => {
						Account.deleteUser(user.account_id).then(() => {
							resolve()
						}).catch(_this.$root.errorWrapper(e => {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {
								case 'account_not_found':
									reject('The account you are trying to remove could not be found.')
									break

								default:
									// No default
								}
							}
						}))
					})
				}
			}).then(() => {
				_this.$swal({
					title: 'Success',
					html: successMessage,
					type: 'success',
					timer: 2000
				}).then(() => {
					_this.getUsers(_this.activePage)
				}, dismiss => {
					_this.getUsers(_this.activePage)
				})
			}, dismiss => {
				// Do nothing on dismiss
			})
		},
		/**
		 * To resend an expired user invitation
		 * @function
		 * @param {object} user - The user that is being re-invited.
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		resendUserInvitation (user) {
			let _this = this
			const username = user.name.first_name && user.name.last_name ? user.name.first_name + ' ' + user.name.last_name : user.email

			return Auth.resendInvite(user.account_id)
			.then(response => {
				_this.$swal({
					title: 'Success',
					html: 'Invitation was sent to ' + username + '.',
					type: 'success',
					timer: 2000
				})

				user.invite_status = 'pending'
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'email_failed':
						_this.$swal({
							title: 'Error',
							html: 'There was an error sending the invitation to ' + username + '.',
							type: 'warning',
							timer: 2000
						})
						break

					case 'already_accepted':
						_this.$swal({
							title: 'Error',
							html: username + ' has already accepted their invitation.',
							type: 'warning',
							timer: 2000
						})
						break

					case 'account_not_found':
						_this.$swal({
							title: 'Error',
							html: 'There was an error sending the invitation to ' + username + '.',
							type: 'warning',
							timer: 2000
						}).then(() => {
							_this.getUsers(_this.activePage)
						}, dismiss => {
							_this.getUsers(_this.activePage)
						})
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To initialize the invite user process by redirecting to the invite user route
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		inviteUser () {
			this.$router.push(this.baseRoute + '/invite_user')
		}
	},
	components: {
		Breadcrumb,
		Dropdown,
		LoadingScreen,
		NoResults,
		PageResults,
		Pagination,
		Typeahead,
		InviteUser
	},
	watch: {
		/**
		 * Watch `$route` so that we can check if we are on the proper panel after each change
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name !== this.baseRouteName) {
				this.activePanel = false
			} else {
				this.activePanel = true
				this.getUsers(this.activePage)
			}
		},
		/**
		 * Watch `sortBy.order` so that we can update the active page and retrieve the users with the updated sort order.
		 * @function
		 * @returns {undefined}
		 * @memberof Users
		 * @version 0.0.8
		 */
		'sortBy.order' () {
			if (this.sortBy.field) {
				if (parseInt(this.activePage) === 1) {
					this.getUsers(1)
				} else {
					this.activePageUpdate(1)
				}
			}
		}
	}
}
</script>
<style>
.search-content-4 .search-table td.profile-image-table-row {
	width:75px;
	padding-right: 0px;
}
.missing-profile-image {
	position: relative;
	display: inline-block;
	color: #fff;
	background-color: rgba(44, 62, 80, 0.5);
	width: 100%;
	height: 0;
	padding: 50% 0;
	border-radius: 50%;
	text-align: center;
	font-size: 15px;
	line-height: 0;
}
</style>


// WEBPACK FOOTER //
// Users.vue?894b0fa8